/* eslint-disable no-unused-vars */
import React, { Component, useCallback } from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';
import { Color } from '../../../asset/styles';

import { Radio } from '../../../../common/primitive';

const StyledContainer = styled.div`
  position: relative;
  color: ${Color.text.gray};
  cursor: pointer;
  line-height: 1.5;
  text-align: center;
  width: 20%;
  height: 50px;
  font-size: 16px;
  box-sizing: border-box;

  /* radio */
  > input {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }
  > input + label {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    height: 50px;
    font-weight: 500;
    color: ${props => props.color};
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;

    &:before {
      box-sizing: border-box;
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      border: solid 2px ${props => props.color};
      border-radius: 25px;
      box-sizing: border-box;
      cursor: pointer;
      height: 50px;
      width: 50px;
      background-color: ${Color.text.white};
    }

    .nps-radio-text {
      position: relative;
      cursor: pointer;
    }
  }

  > input:checked + label {
    color: ${Color.text.white};
    &:before {
      background-color: ${props => props.color};
    }
  }
`;

/**
 * Nps 5段階選択 radio を作成します 【例】あなたはこのキャンペーンを家族や友達に薦めたいと思いますか？
 * - inspector - element debug 用に `.RadioWithLabel` class name を付与します
 * - input[type=radio] を透明化し非表示にします
 * - label:before に擬似 radio parts を作成し表示します
 * @param {string} id input[type=radio] に付与する id - label `for` 属性値にも使用します
 * @param {string} label label text
 * @param {string} name input[type='radio'] name
 * @param {string} [color=Color.border.gray] circle(radio button) border color - {@link Color}
 * @param {boolean} disabled - radio disabled attribute
 * @param {*} props React.props input[type=radio] {@link Radio} に全て付与します - { checked: boolean, onChange: function, data-index: number }
 * @return {*} Nps 5段階選択 radio を返します
 * @constructor
 * @since 20191210 - add props.checked, embedded / popup 切替時の radio button check 状態維持に使用します
 */
const NpsRadioWithLabel = ({
  id,
  label,
  name,
  color = Color.border.gray,
  // checked = false,
  disabled = false,
  ...props
}) => {
  // console.log('NpsRadioWithLabel', id, props)
  //
  // const shouldChecked = useCallback(() => {
  //   return checked
  // }, [
  //   checked,
  // ])
  // props: { checked: boolean, onChange: function, data-index: number }
  return (
    <StyledContainer className={'NpsRadioWithLabel'} color={color}>
      <Radio id={id} name={name} disabled={disabled} {...props} />
      <label htmlFor={id}>
        <span className={'nps-radio-text'}>{label}</span>
      </label>
    </StyledContainer>
  );
};

// NpsRadioWithLabel.propTypes = {
//   id: PropTypes.string.isRequired,
//   label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
// };

export default NpsRadioWithLabel;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/nps/children/NpsRadioWithLabel.js